import { DollarSign, ClipboardList, Users, Heart } from 'lucide-react';
import './WhyChooseUs.css';

const WhyChooseUs = () => {
    const benefits = [
        {
            icon: DollarSign,
            title: "Affordable Living",
            description: "Exceptional care and amenities at competitive, transparent rates.",
            gradient: "linear-gradient(135deg, #d4a575 0%, #b8935f 100%)"
        },
        {
            icon: ClipboardList,
            title: "Personalized Care",
            description: "Custom wellness plans tailored to meet individual needs and preferences.",
            gradient: "linear-gradient(135deg, #0a3f26 0%, #0d5233 100%)"
        },
        {
            icon: Users,
            title: "Expert Staff",
            description: "A professional, compassionate team dedicated to your well-being 24/7.",
            gradient: "linear-gradient(135deg, #d4a575 0%, #b8935f 100%)"
        },
        {
            icon: Heart,
            title: "Vibrant Community",
            description: "Engaging daily activities and a warm, welcoming environment to call home.",
            gradient: "linear-gradient(135deg, #0a3f26 0%, #0d5233 100%)"
        }
    ];

    return (
        <section className="why-choose-us-section">
            {/* Background Elements */}
            <div className="why-bg-gradient"></div>
            <div className="why-bg-pattern"></div>

            <div className="why-container">
                {/* Header */}
                <div className="why-header">
                    <div className="why-badge">
                        <Heart size={18} className="badge-icon" />
                        <span>Excellence in Senior Living</span>
                    </div>
                    <h2 className="why-title">Why Choose Us</h2>
                    <p className="why-subtitle">
                        Experience compassionate care, comfort, and community at Hollywood Royale.
                    </p>
                    <div className="title-underline">
                        <span className="underline-dot"></span>
                        <span className="underline-line"></span>
                        <span className="underline-dot"></span>
                    </div>
                </div>


                {/* Benefits Grid */}
                {/* Benefits List - Matching layout style */}
                <div className="why-features-list">
                    {benefits.map((benefit, index) => {
                        const Icon = benefit.icon;
                        return (
                            <div key={index} className="why-feature-item" style={{ animationDelay: `${index * 0.1}s` }}>
                                <div className="why-feature-bullet">
                                    <Icon size={24} />
                                </div>
                                <div className="why-feature-text">
                                    <h3 className="why-feature-title">{benefit.title}</h3>
                                    <span className="why-feature-desc"> - {benefit.description}</span>
                                </div>
                            </div>
                        );
                    })}
                </div>

                {/* CTA Section */}
                <div className="why-cta">
                    <div className="why-cta-content">
                        <h3>Ready to Experience the Difference?</h3>
                        <p>Join us for a tour and see why families trust Hollywood Royale.</p>
                        <div className="why-cta-buttons">
                            <a href="/contact" className="why-cta-btn primary">
                                Schedule a Tour
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                                    <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </a>
                            <a href="/contact" className="why-cta-btn secondary">
                                Contact Us
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default WhyChooseUs;
